import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../../layouts/noc/NocNavBar';
import FiberSitesPublicIpBody from './FiberSitesPublicIpBody';
import useCheckTwoDepartments from '../../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../../utils/config';
import { useUser } from '../../../../../../../hooks/shared/user/useUser';
import FiberSitesPublicIpProvider from './provider/FiberSitesPublicIpProvider';
import { VICE_PRESIDENT_FSE } from '../../../../../../../utils/departments/helpers';

const FiberSitesPublicIp = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <FiberSitesPublicIpProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - Fiber Sites Public IP" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <FiberSitesPublicIpBody />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </FiberSitesPublicIpProvider>
    </div>
  );
};

export default FiberSitesPublicIp;
